module.exports = __webpack_public_path__ + "img/carousel_banner03.4f6144ab.jpg";